/* __next_internal_client_entry_do_not_use__ default auto */ import * as React from 'react';
import PropTypes from 'prop-types';
import debounce from "../utils/debounce.js";
import { ownerWindow, unstable_useEnhancedEffect as useEnhancedEffect } from "../utils/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
const styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
/**
 * @ignore - internal component.
 * The component originates from https://github.com/STORIS/react-scrollbar-size.
 * It has been moved into the core in order to minimize the bundle size.
 */ export default function ScrollbarSize(props) {
    const { onChange, ...other } = props;
    const scrollbarHeight = React.useRef();
    const nodeRef = React.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    useEnhancedEffect(()=>{
        const handleResize = debounce(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) {
                onChange(scrollbarHeight.current);
            }
        });
        const containerWindow = ownerWindow(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    React.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ _jsx("div", {
        style: styles,
        ...other,
        ref: nodeRef
    });
}
"production" !== "production" ? ScrollbarSize.propTypes = {
    onChange: PropTypes.func.isRequired
} : void 0;
